import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Card, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useCobConfig } from '~/client-flow/clientOb/CobConfigContext';
import { replacePlaceholders } from '~/utils/introductory-message.utils';
import styles from './Introduction.module.scss';
export const GetIntroductionTID = ()=>getTestIds();
export const Introduction = ()=>{
    var _relationship_buyer_firstName;
    const { relationship } = useCobConfig();
    const { IntroductionTestIds } = useMemo(()=>GetIntroductionTID(), []);
    return /*#__PURE__*/ _jsx(Card, {
        bi: {
            name: 'introduction_card'
        },
        className: styles.card,
        testId: IntroductionTestIds.Card(),
        children: /*#__PURE__*/ _jsx(Typography, {
            showWhiteSpaces: true,
            breakWords: true,
            testId: IntroductionTestIds.Text(),
            children: replacePlaceholders(relationship.customNotificationText, (_relationship_buyer_firstName = relationship.buyer.firstName) !== null && _relationship_buyer_firstName !== void 0 ? _relationship_buyer_firstName : '', relationship.vendor.name)
        })
    });
};
